import { Donvi } from './donvi';

export class Dmlinhvucgopy {
    id: number;
    kyhieu: string;
    ten: string;
    isactive: number;
    dinhnghia: string;
    hieuluc: number;
    createddate: Date;
    createdbyuserid: number;
    modifieddate: Date;
    modifiedbyuserid: number;  
    iddonvi: number;
    dmdonvi: Donvi;    
   }